export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  whatsappNumber: "27712431886",
  whatsappDisplay: "071 243 1886",
  callNumber: "+27810294973",
  callDisplay: "081 029 4973",
  email: "abongilegoci7@gmail.com",
};

export const waLink = (text) =>
  `https://wa.me/${CONTACT.whatsappNumber}${
    text ? `?text=${encodeURIComponent(text)}` : ""
  }`;

export const WA_DEFAULT_MSG =
  "Hello NGCONDE Courier Service, I'd like to discuss a delivery contract / subcontracting opportunity.";

export const SERVICE_OPTIONS = [
  "Dedicated Bakkie Fleet Subcontracting",
  "E-Commerce Last-Mile Overflow Capacity",
  "Scheduled Regional Distribution Runs",
  "Ad-Hoc / Peak Season Courier Relief",
  "Warehouse-to-Retail Store Drops",
  "Long-term Logistics Master Agreement",
];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -88 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?q=80&w=2071&auto=format&fit=crop",
  bakkie: "https://images.unsplash.com/photo-1569153689628-df82366aa3bb?q=80&w=1600&auto=format&fit=crop",
  warehouse: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=1600&auto=format&fit=crop",
  sorting: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?q=80&w=1600&auto=format&fit=crop",
  highway: "https://images.unsplash.com/photo-1485575301924-6891ef935dcd?q=80&w=2071&auto=format&fit=crop",
  vanLoad: "https://images.unsplash.com/photo-1620455800201-7f00aeef12ed?q=80&w=1600&auto=format&fit=crop",
  isuzuBakkie: "https://images.unsplash.com/photo-1626775829164-a4607991f1de?q=80&w=1600&auto=format&fit=crop",
  isuzuTruck: "https://static.prod-images.emergentagent.com/jobs/9249dba4-f346-4ac7-85f0-bab7ca698c03/images/3c47e09a229449f3ac07a3dfc6e6e1a44da590d762db443defc1b464cbbd5520.jpeg",
};
